export const messages = {
    en: {
      mqttLog: {
        search: {
          title: 'Search Conditions',
          startTime: 'Start Time',
          endTime: 'End Time',
          startTimePlaceholder: 'Select start time',
          endTimePlaceholder: 'Select end time'
        },
        list: {
          title: 'MQTT Log'
        },
        table: {
          id: 'ID',
          businessId: 'Business ID',
          business: 'Business',
          topic: 'Topic',
          content: 'Content',
          remark: 'Remark'
        },
        fetchError: 'Failed to fetch MQTT logs'
      },
    },
    zh: {
      mqttLog: {
        search: {
          title: '查询条件',
          startTime: '开始时间',
          endTime: '结束时间',
          startTimePlaceholder: '请选择开始时间',
          endTimePlaceholder: '请选择结束时间'
        },
        list: {
          title: 'MQTT日志'
        },
        table: {
          id: '编号',
          businessId: '业务ID',
          business: '业务',
          topic: 'Topic',
          content: '内容',
          remark: '备注'
        },
        fetchError: '获取MQTT日志失败'
      }
    }
  }